
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_cqcqk_237up_9",
  "wrapper": "awsui_wrapper_cqcqk_237up_13",
  "elementWrapper": "awsui_elementWrapper_cqcqk_237up_17",
  "markerWrapper": "awsui_markerWrapper_cqcqk_237up_21",
  "placement-right": "awsui_placement-right_cqcqk_237up_26",
  "placement-left": "awsui_placement-left_cqcqk_237up_31",
  "inlineWrapper": "awsui_inlineWrapper_cqcqk_237up_36"
};
  